<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules">
    <bear-trade-center @change="inputChangeHandle"></bear-trade-center>
    <label class="form-house-trade-center" :style="style" @click="fnShow">{{form[options.Key]}}</label>
    <!-- <bear-input v-model="form[options.Key]" :attrs="attrs" @input="inputChangeHandle" :disabled="options.Disabled"></bear-input> -->
  </tender-form-label>
</template>
<script>
import _ from "lodash";
import BearInput from "~@/input/src";
import { HouseUtils } from '@/common/tender/house/utils'
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
import tenderHook from "../../../js/hooks";
import { mapActions, mapState } from 'vuex';
export default {
  name: "FormHouseTradeCenter",
  mixins: [mixForFormItem],
  components: { BearInput },
  data() {
    return {
    };
  },
  computed: {
    value() {
      let {form, options} = this
      return form[options.Key]
    },
    style() {
      return {
        minWidth: this.attrs.minWidth
      }
    }
  },
  created() {
    this.setDefaultValue();
  },
  methods: {
    ...mapActions(['houseStore/initComps']),
    setDefaultValue() {
      let { form = {}, options = {} } = this;
      utils.readyToSetFormItemDefault(form, options).then(() => {
        this.setFormItemValue(options.Value || "");
      }).catch(() => null);
    },
    inputChangeHandle({regions}) {
      HouseUtils.changeAreaRadio(this.form, regions)
      tenderHook.refEvent(null, this);
      this.doValidate();
    },
    fnShow() {
      this['houseStore/initComps']({
        key: 'bearTradeCenter',
        args: {
          key: this.options.Key
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.form-house-trade-center {
  position: relative;
  z-index: 1;
  display: inline-block;
  text-indent: 0;
  word-break: break-all;
  line-height: 1;
  padding: 5px 5px;
  width: auto;
  min-width: 100px;
  cursor: text;
  text-align: left;
  outline: none;
  color: #2393e4;
  border-bottom: 1px solid black;
  cursor: pointer;
  &:before {
    content: '';
    display: inline-block;
  }
}
</style>
<style lang="scss">
.tender-form-item {
  .is-error {
    .form-house-trade-center {
      border-bottom: 1px solid red;
      & + .el-form-item__error {
        position: relative;
        display: inline;
        padding: 5px 5px;
        background: #efdede;
        border-bottom: 1px solid red;
        border-radius: 0 3px 0 0;
      }
    }
  }
}
</style>